module.exports = require("bluebird");


//////////////////
// WEBPACK FOOTER
// external "bluebird"
// module id = 33
// module chunks = 0